<ng-container *ngIf="page$ | async as home">
  <ng-container *ngIf="home?.data.attributes?.Banner">
    <widget-banner [widget]="home.data.attributes.Banner" [title]="title" (search)="onSearch($event)"></widget-banner>
  </ng-container>

  <ng-container *ngIf="articles$ | async as articles">
    <div class="w-full mx-auto max-w-screen-xl">
      <div class="flex justify-between mt-6 w-full max-w-screen-xl mx-auto px-4 md:px-14">
        <mat-form-field class="w-52 border-red-motorbest-600 text-red-motorbest-600 rounded-none">
          <mat-select class="border-red-motorbest-600 text-red-motorbest-600 rounded-none" [formControl]="sortField">
            <mat-option value="publishDate:desc">
              {{ "Most Recent" | transloco }}
            </mat-option>
            <mat-option value="publishDate:asc">
              {{ "Older" | transloco }}
            </mat-option>
            <mat-option value="title:asc">
              {{ "Sort A-Z" | transloco }}
            </mat-option>
            <mat-option value="title:desc">
              {{ "Sort Z-A" | transloco }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <button mat-stroked-button class="border-red-motorbest-600 text-red-motorbest-600 rounded-none" *ngIf="false">
          <mat-icon svgIcon="mat_outline:filter_list" class="text-primary icon-size-4 mr-4"></mat-icon>
          {{ "Filters" | transloco }}
        </button>
      </div>

      <widget-news style="margin-top: -28px" [widget]="{
          layoutFormat: 'xLine',
          numberOfColumns: 4,
          name: 'Most Recent' | transloco,
          numberOfProducts: articles?.data?.length,
          showImage: home?.data.attributes?.ShowImage,
          showDate: home?.data.attributes?.showDate,
          showExcerpt: home?.data.attributes?.showExcerpt,
          showTitle: home?.data.attributes?.ShowTitle,
          items: articles,
          showSeeAllLink: false,
          classes: 'pt-1',
        }" [showListTitle]="false" [showPagination]="false" [showSeeAllLink]="false"></widget-news>
    </div>
    <section class="max-w-screen-xl mx-auto px-4 md:px-14 py-7 ">
      <div class="flex justify-center">
        <tx-pagination #pagination [collectionSize]="articles?.meta?.pagination?.total"
          [pageSize]="articles?.meta?.pagination?.pageSize" [currentPage]="articles?.meta?.pagination?.page"
          [firstLastButtons]="false" [maxSize]="3" [previousLabel]="'Previous' | transloco "
          [nextLabel]="'Next' | transloco " (page)="handlePageEvent($event)"></tx-pagination>
      </div>
    </section>
  </ng-container>
</ng-container>